function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-cartIc,.cls-cartIc-2{fill:#5b4e03;}.cls-cartIc{fill-rule:evenodd;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_70",
  "data-name": "Layer 70"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-cartIc",
  d: "M16.17,22a3,3,0,1,1-3,3A3,3,0,0,1,16.17,22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-cartIc",
  d: "M27,21.88A3.09,3.09,0,1,1,23.88,25,3.09,3.09,0,0,1,27,21.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-cartIc-2",
  d: "M33,2.27a2.15,2.15,0,0,0-2.7,1.42S28.13,9.11,27,13a2.84,2.84,0,0,1-3.19,2.22H19.27A3.18,3.18,0,0,1,16.08,13c-2-3.88-5.26-10.9-5.26-10.9A3.5,3.5,0,0,0,7.88,0H2.16a2.17,2.17,0,0,0,0,4.34H7l6,12c1.27,2.14,2.47,3.22,4.49,3.22h8.29c2.63,0,4-.94,4.69-3.22L34.4,5A2.18,2.18,0,0,0,33,2.27Z"
})));

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34.49 28.06",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cart.d2728ff7.svg";
export { ForwardRef as ReactComponent };